import React from 'react';

export function useHasVerticalScroll<T extends HTMLElement>() {
    const ref = React.useRef<T>(null);
    const [hasScroll, setHasScroll] = React.useState(false);

    React.useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const checkScroll = () => {
            setHasScroll(el.scrollHeight > el.clientHeight);
        };

        checkScroll();

        const resizeObserver = new ResizeObserver(checkScroll);
        resizeObserver.observe(el);

        return () => resizeObserver.disconnect();
    }, []);

    return { ref, hasScroll };
}
